import { TonLogo } from "based-assets";
import { defineChain } from "viem";
import { IChain, ChainSymbols, ChainIds } from "./types";
import { networkTon } from "../networks";

export const chainTon: IChain = defineChain({
  id: ChainIds.ton,
  symbol: ChainSymbols.ton,
  name: "TON",
  logo: TonLogo,
  network: networkTon,
  nativeCurrency: { name: "Toncoin", symbol: "TON", decimals: 9 },
  rpcUrls: {
    default: { http: ["https://toncenter.com/api/v2/json-rpc"] },
  },
  blockExplorers: {
    default: {
      name: "Tonviewer",
      url: "https://tonviewer.com",
      hash: "https://tonviewer.com/tx/{{addr}}",
      address: "https://tonviewer.com/address/{{addr}}",
    },
  },
  testnet: false,
});

export const chainTonDevnet: IChain = defineChain({
  id: ChainIds.tonDevnet,
  symbol: ChainSymbols.tonDevnet,
  name: "TON Testnet",
  logo: TonLogo,
  network: networkTon,
  nativeCurrency: { name: "Toncoin", symbol: "TON", decimals: 9 },
  rpcUrls: {
    default: { http: ["https://toncenter.com/api/v2/json-rpc"] },
  },
  blockExplorers: {
    default: {
      name: "Tonviewer",
      url: "https://tonviewer.com",
      hash: "https://tonviewer.com/tx/{{addr}}",
      address: "https://tonviewer.com/address/{{addr}}",
    },
  },
  testnet: true,
});
